import { API_GET, API_POST } from "../config/axiosConfig";

export const getAchievements = async () => {
    try {
        const respAxios = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/achievements`);
        if (respAxios?.status === 200) {
            return respAxios?.data?.achievements || [];
        }
        return [];
    } catch (error) {
        console.error("Error fetching achievements:", error);
        return [];
    }
};
export const getAllClientsTag = async (roomId) => {
    try {
        const respAxios = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/clients-tag`);
        if (respAxios?.status === 200) {
            return respAxios?.data?.clientTags || [];
        }
        return [];
    } catch (error) {
        console.error("Error fetching clients tags:", error);
        return [];
    }
};

export const addAchievementToRoom = async (roomId, data) => {
    try {
        const respAxios = await API_POST(`${process.env.REACT_APP_CORE_API_URI}/web/achievements/room/${roomId}`, data);
        return respAxios;
    } catch (error) {
        console.error("Error adding achievement to room:", error);
        return error;
    }
};

export const addAchievement = async (data) => {
    try {
        console.log("Adding achievement with data:", data);
        const respAxios = await API_POST(`${process.env.REACT_APP_CORE_API_URI}/web/achievements`, data);
        console.log("Achievement added successfully:", respAxios);
        return respAxios;
    } catch (error) {
        console.error("Error adding achievement to room:", error);
        return error;
    }
};
